import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  label?: string;
  className?: string;
}

export default function BackButton({ label = "Geri", className = "" }: BackButtonProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate("/panel");
      }}
      className={`h-10 px-4 rounded-full border border-farm-border bg-white text-farm-brown text-sm font-semibold hover:bg-farm-cream flex items-center gap-2 ${className}`}
    >
      <i className="ri-arrow-left-line text-base" />
      {label}
    </button>
  );
}
